var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlanetProtection = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Ecology-Globe-Hand-1--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Ecology Globe Hand 1 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.75 0a9.26 9.26 0 0 0 -8.87 11.89 0.5 0.5 0 0 0 0.48 0.36h1.89a4.43 4.43 0 0 1 1.27 0.18 0.53 0.53 0 0 0 0.39 0 0.57 0.57 0 0 0 0.24 -0.31l0.33 -1.24a0.8 0.8 0 0 1 0.77 -0.59 1.5 1.5 0 0 0 1.5 -1.5v-2a1.5 1.5 0 0 0 -1.5 -1.5H9.19A0.24 0.24 0 0 1 9 5.11a0.27 0.27 0 0 1 0 -0.26 7.24 7.24 0 0 1 11.49 0 0.46 0.46 0 0 1 0.1 0.38 0.5 0.5 0 0 1 -0.2 0.33 1.5 1.5 0 0 0 -0.63 1.22v2a0.5 0.5 0 0 1 -0.5 0.5h-0.61a1.5 1.5 0 0 0 -1.43 2l0.34 1a1.48 1.48 0 0 0 1.42 1h1.35a0.24 0.24 0 0 1 0.22 0.14 0.23 0.23 0 0 1 0 0.26A7.19 7.19 0 0 1 18 15.73a1 1 0 0 0 0.45 1.89 1 1 0 0 0 0.45 -0.11A9.25 9.25 0 0 0 14.75 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.25 18.25h-8.5a0.5 0.5 0 0 1 -0.5 -0.5 0.51 0.51 0 0 1 0.5 -0.5h4a0.51 0.51 0 0 0 0.5 -0.5 3 3 0 0 0 -3 -3h-6A0.25 0.25 0 0 1 2 13.5a1 1 0 0 0 -2 0V23a1 1 0 0 0 2 0 0.25 0.25 0 0 1 0.25 -0.25h16.5a0.5 0.5 0 0 0 0.5 -0.5 4 4 0 0 0 -4 -4Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlanetProtection);
export default ForwardRef;